import { createContext, useContext, useMemo, useState } from "react";
import LoaderUI from "../Reuse/UI/Loader";

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loaderCount, setLoaderCount] = useState([]);

  // call this function when you want to authenticate the user
  const showLoader = async () => {
    setLoaderCount((preState) => [...preState, true]);
  };
  const hideLoader = async () => {
    setLoaderCount((preState) => preState.slice(0, -1));
  };

  const value = useMemo(
    () => ({
      showLoader,
      hideLoader,
      isLoader: loaderCount.length>0,
    }),
    [loaderCount]
  );
  return (
    <LoaderContext.Provider value={value}>
      <LoaderUI />
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => {
  return useContext(LoaderContext);
};
